<span class="devider-text">
  <ng-content></ng-content>
</span>
